export default __webpack_public_path__ + "static/media/Clericot.8ef1c009.jpg";